.layout {
  min-height: 100vh;
}

.content {
  margin: 0 24px;
}

.contentMain {
  margin: 0 15px !important;
}